import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "star", "label"]
  static values = { score: { type: Number, default: 0 } }

  connect() {
    this.hoverScore = 0
    this.syncFromInput()
    this.render()
    this.updateLabel()
  }

  select(event) {
    const score = event.params.score
    this.scoreValue = score
    this.inputTarget.value = score
    this.render()
    this.updateLabel()
  }

  preview(event) {
    this.hoverScore = event.params.score
    this.render()
  }

  resetPreview() {
    this.hoverScore = 0
    this.render()
  }

  syncFromInput() {
    const value = parseInt(this.inputTarget.value, 10)
    if (value >= 1 && value <= 5) {
      this.scoreValue = value
    }
  }

  render() {
    const active = this.hoverScore || this.scoreValue

    this.starTargets.forEach((star, index) => {
      const starValue = index + 1
      const filled = starValue <= active
      star.classList.toggle("star-rating__star--filled", filled)
      star.setAttribute(
        "aria-checked",
        starValue === this.scoreValue ? "true" : "false",
      )
    })
  }

  updateLabel() {
    if (!this.hasLabelTarget) return

    const labels = {
      0: "Tap to rate",
      1: "1 star",
      2: "2 stars",
      3: "3 stars",
      4: "4 stars",
      5: "5 stars",
    }

    this.labelTarget.textContent = labels[this.scoreValue] || labels[0]
  }
}
